import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ContentTemplate from "./content-template"
import NoContentAfterVideo from "./no-content-after-video"
import { convertTimeToAziaZone } from "../../functions/convert-time-to-azia-timezone"

// ファーストビューアニメーションの終了後に流すコンテンツを指定する
// 現在「アニメーションなし」の場合のテスト中（2023/02/15）
// TODO：アニメーションを削除する場合、ファイル名を修正する

export default function ContentAfterVideo() {
  const data = useStaticQuery (
    graphql`
    query TopContentQuery {
      microcmsTop {
        note {
          id
          title
          subtitle
          tags {
            id
            name
            type
          }
          publishedAt
          thumbnail {
            url
          }
          middle_category {
            id
            name
            display_color
          }
        }
        program {
          id
          title
          publishedAt
          thumbnail {
            url
          }
        }
        seminar {
          id
          title
          tags {
            id
            name
            type
          }
          publishedAt
          image {
            url
          }
        }
        publication {
          id
          title
          publishedAt
          display_image {
            url
          }
          type
        }
      }
    }`
  )

  // 管理画面側でコンテンツが何も設定されていなかった場合
  if (data.microcmsTop === null) {
    return <NoContentAfterVideo />
  }

  let publishDate = ''
  let title = ''
  let subtitle = ''
  let imageUrl = ''
  let tagName = ''
  let link = ''
  let category = ''

  if(data.microcmsTop.note !== null) {
    publishDate = convertTimeToAziaZone(data.microcmsTop.note.publishedAt,'YYYY.MM.DD')
    title = data.microcmsTop.note.title
    subtitle = data.microcmsTop.note.subtitle
    imageUrl = data.microcmsTop.note.thumbnail ? data.microcmsTop.note.thumbnail.url : ''
    tagName = data.microcmsTop.note.tags.length ? data.microcmsTop.note.tags[0].name : ''
    link = `/note/${data.microcmsTop.note.id}`
    category = data.microcmsTop.note.middle_category ? data.microcmsTop.note.middle_category : '' 
  } else if(data.microcmsTop.program !== null) {
    publishDate = convertTimeToAziaZone(data.microcmsTop.program.publishedAt,'YYYY.MM.DD')
    title = data.microcmsTop.program.title
    imageUrl = data.microcmsTop.program.thumbnail ? data.microcmsTop.program.thumbnail.url : ''
    link = `/program/${data.microcmsTop.program.id}`
  } else if(data.microcmsTop.seminar !== null) {
    publishDate = convertTimeToAziaZone(data.microcmsTop.seminar.publishedAt,'YYYY.MM.DD')
    title = data.microcmsTop.seminar.title
    imageUrl = data.microcmsTop.seminar.image ? data.microcmsTop.seminar.image.url : ''
    tagName = data.microcmsTop.seminar.tags.length ? data.microcmsTop.seminar.tags[0].name : ''
    link = `/seminar/${data.microcmsTop.seminar.id}`
  } else {
    publishDate = convertTimeToAziaZone(data.microcmsTop.publication.publishedAt,'YYYY.MM.DD')
    title = data.microcmsTop.publication.title
    imageUrl = data.microcmsTop.publication.display_image ? data.microcmsTop.publication.display_image.url : ''
    link = data.microcmsTop.publication.type[0] === "書籍" ?
      `/publication/book/${data.microcmsTop.publication.id}`
      :
      `/publication/media/${data.microcmsTop.publication.id}`
  }

  return (
    <ContentTemplate
      publishDate={publishDate}
      title={title}
      subtitle={subtitle}
      imageUrl={imageUrl}
      tagName={tagName}
      link={link}
      category={category}
    />
  )
}
